var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-swipe',{attrs:{"vertical":"","autoplay":4000,"show-indicators":false}},[_c('van-swipe-item',[_c('div',{staticClass:"content-text"},[_vm._v(_vm._s(_vm.dataList&&_vm.dataList.length > 0 ? _vm.dataList[0].noticeTitle : ''))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }